import { StatusBadge } from "@/components/app/common";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate } from "@/lib/format";

const Card = ({ k, status, sub, testid }) => (
  <div className="rounded-md border border-slate-200 bg-white p-3" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-1">{k}</div>
    <StatusBadge status={status} testid={`${testid}-status`} />
    {sub && <div className="text-[11px] text-slate-500 mt-1">{sub}</div>}
  </div>
);

// LM first page: one card per stage, left to right in process order
export function StageSummary({ orderId, refreshKey }) {
  const { data: s } = useFetch(`/orders/${orderId}/stage-summary?k=${refreshKey || 0}`);
  if (!s) return null;
  const e = s.execution;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-8 gap-2 mb-4" data-testid="lm-stage-summary">
      <Card k="LM status" status={s.lm_status} testid="stage-lm" />
      <Card k="Execution" status={e.status} sub={e.date ? `${fmtDate(e.date)}${e.by ? ` · ${e.by}` : ""}` : null} testid="stage-execution" />
      <Card k="Dispatch plan" status={s.planning.status} sub={`${s.planning.plans} plan(s) · ${s.planning.planned_qty} / ${s.planning.qty_total} qty`} testid="stage-planning" />
      <Card k="Ready for QC" status={s.ready_for_qc.status} sub={s.ready_for_qc.pending ? `${s.ready_for_qc.pending} waiting for QC` : `${s.ready_for_qc.submissions} submission(s)`} testid="stage-rfq" />
      <Card k="QC" status={s.qc.status} sub={s.qc.last_remarks || `${s.qc.approved} approved · ${s.qc.rejected} rejected · ${s.qc.on_hold} on hold`} testid="stage-qc" />
      <Card k="Invoice" status={s.invoice.status} sub={s.invoice.numbers.join(", ") || "no invoice yet"} testid="stage-invoice" />
      <Card k="Movement" status={s.movement.status} sub={s.movement.movements ? `${s.movement.movements} movement(s) · last ${s.movement.latest_movement_no}` : null} testid="stage-movement" />
      <Card k="Delivery" status={s.delivery.status} sub={`POD received ${s.delivery.delivered_pod} / ${s.delivery.dispatches}`} testid="stage-delivery" />
    </div>
  );
}
